import React from 'react';

import { ErrorLabel } from 'components/Input/styled';

import { BaseCheckboxProps } from './interfaces';
import { Wrapper, Label, InputCheckbox } from './styled';

/**
 * Stateless Checkbox component
 */
export const BaseCheckbox = React.forwardRef<HTMLInputElement, BaseCheckboxProps>(
  function CheckboxBase(
    { name, label = '', error, disabled, checked, labelProps, errorLabelProps, ...props },
    ref
  ) {
    return (
      <Wrapper>
        <InputCheckbox
          aria-label={label}
          readOnly
          {...props}
          name={name}
          id={name}
          type='checkbox'
          checked={checked}
          disabled={disabled}
          aria-disabled={disabled}
          aria-invalid={!!error}
          ref={ref}
        />
        <Label htmlFor={name} {...labelProps}>
          {labelProps?.children || label}
        </Label>
        {!!error && <ErrorLabel {...errorLabelProps}>{error}</ErrorLabel>}
      </Wrapper>
    );
  }
);
